import React, { useEffect, useState } from 'react';
import { TextField, CnpjField, SelectField, Field } from '../fundo_liquido/fields';
import { Opt } from '../fundo_liquido/mock';
import { useToast } from '../../../components/toast_notification/ToastProvider';
import { listarEmissores, cadastrarEmissor } from './ativosService';

const NOVO = '__novo__';
const soDigitos = (s?: string) => (s || '').replace(/\D/g, '');

interface Emissor { id: number; cnpj: string; razao_social: string; }

const EmissorField: React.FC<{
  label?: string;
  value?: string;
  required?: boolean;
  hint?: string;
  onChange: (id?: string, nome?: string) => void;
}> = ({ label = 'Emissor', value, required, hint, onChange }) => {
  const toast = useToast();
  const [emissores, setEmissores] = useState<Emissor[]>([]);
  const [criando, setCriando] = useState(false);
  const [novoCnpj, setNovoCnpj] = useState('');
  const [novaRazao, setNovaRazao] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { listarEmissores().then(setEmissores).catch(() => setEmissores([])); }, []);

  const options: Opt[] = [
    ...emissores.map((e) => ({ value: String(e.id), label: e.razao_social })),
    { value: NOVO, label: '＋ Cadastrar novo emissor' },
  ];

  const aoSelecionar = (v: string) => {
    if (v === NOVO) { setCriando(true); return; }
    onChange(v || undefined, emissores.find((e) => String(e.id) === v)?.razao_social);
  };

  const criar = async () => {
    if (!soDigitos(novoCnpj) || !novaRazao.trim()) {
      toast.warning('Informe o CNPJ e a razão social do emissor.');
      return;
    }
    setSalvando(true);
    try {
      const e = await cadastrarEmissor(novoCnpj, novaRazao);
      setEmissores((prev) => (prev.some((x) => x.id === e.id) ? prev : [...prev, e]));
      onChange(String(e.id), e.razao_social);
      setCriando(false); setNovoCnpj(''); setNovaRazao('');
      toast.success(`Emissor "${e.razao_social}" criado.`);
    } catch (err: any) {
      toast.error(`Falha ao criar emissor: ${err?.message ?? 'erro'}`);
    } finally {
      setSalvando(false);
    }
  };

  if (criando) {
    return (
      <Field label={`Novo ${label.toLowerCase()}`} full hint="CNPJ e razão social da empresa emissora.">
        <div className="fl-grid">
          <CnpjField label="CNPJ" value={novoCnpj} onChange={setNovoCnpj} />
          <TextField label="Razão social" value={novaRazao} onChange={setNovaRazao} />
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <button type="button" className="fl-btn fl-btn--primary" onClick={criar} disabled={salvando}>
            {salvando ? 'Criando...' : 'Criar emissor'}
          </button>
          <button type="button" className="fl-btn fl-btn--ghost" onClick={() => setCriando(false)} disabled={salvando}>
            Cancelar
          </button>
        </div>
      </Field>
    );
  }

  return (
    <SelectField
      label={label}
      required={required}
      hint={hint}
      value={value ?? ''}
      onChange={aoSelecionar}
      options={options}
      placeholder="Selecione ou cadastre..."
    />
  );
};

export default EmissorField;
